"use client";

import { useState } from "react";
import { TRAINING_ZONES, formatTime, parseTime, splitFromWatts, wattsFromSplit } from "@/lib/erg";

const inputClass =
  "mt-1 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-gray-900 focus:border-primary focus:outline-none dark:border-gray-600 dark:bg-gray-900 dark:text-gray-100";

export function TrainingZonesCalculator() {
  const [input, setInput] = useState("7:30");

  const total = parseTime(input);
  const valid = total > 0 && Number.isFinite(total);
  const split = total / 4; // 2,000 m is four 500 m splits
  const watts = valid ? wattsFromSplit(split) : NaN;

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 p-5 dark:border-gray-700 dark:bg-gray-900">
      <label className="block max-w-xs text-sm font-medium text-gray-700 dark:text-gray-300">
        Your best 2K time (m:ss)
        <input
          className={inputClass}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="7:30"
          inputMode="decimal"
        />
      </label>

      {valid ? (
        <div className="mt-6" aria-live="polite">
          <p className="text-sm text-gray-700 dark:text-gray-300">
            2K average split <strong className="font-mono">{formatTime(split)}</strong> ={" "}
            <strong className="font-mono">{Math.round(watts)} W</strong>
          </p>
          <div className="mt-4 overflow-x-auto">
            <table className="w-full min-w-[520px] text-left text-sm">
              <thead>
                <tr className="border-b border-gray-200 text-gray-600 dark:border-gray-700 dark:text-gray-400">
                  <th className="py-2 pr-3 font-medium">Zone</th>
                  <th className="py-2 pr-3 font-medium">% of 2K watts</th>
                  <th className="py-2 pr-3 font-medium">Watts</th>
                  <th className="py-2 pr-3 font-medium">Split /500 m</th>
                </tr>
              </thead>
              <tbody>
                {TRAINING_ZONES.map((z) => (
                  <tr key={z.code} className="border-b border-gray-100 align-top dark:border-gray-800">
                    <td className="py-2 pr-3">
                      <div className="font-semibold text-gray-900 dark:text-gray-100">{z.code}</div>
                      <div className="text-xs text-gray-600 dark:text-gray-400">{z.name}</div>
                    </td>
                    <td className="py-2 pr-3 text-gray-700 dark:text-gray-300">
                      {Math.round(z.min * 100)}–{Math.round(z.max * 100)}%
                    </td>
                    <td className="py-2 pr-3 font-mono text-gray-900 dark:text-gray-100">
                      {Math.round(watts * z.min)}–{Math.round(watts * z.max)}
                    </td>
                    {/* Higher watts = faster (smaller) split, so the range flips. */}
                    <td className="py-2 pr-3 font-mono text-gray-900 dark:text-gray-100">
                      {formatTime(splitFromWatts(watts * z.max))}–{formatTime(splitFromWatts(watts * z.min))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <p className="mt-6 text-sm text-amber-700 dark:text-amber-400">
          Enter a 2K time such as 7:30 or 6:58.4.
        </p>
      )}
    </div>
  );
}
